import userProfileIcon from "../../assets/user_profile_icon.svg";
import chatbotIcon from "../../assets/chatbot_icon.svg";
import chatHistoryIcon from "../../assets/chat_history_icon.svg";
import chatIcon from "../../assets/chat_icon_black.svg";
import { Link } from "react-router";
import { useGetChatSessions } from "../Chatbot/api";

export default function QuickLinks() {
  const { data: sessions, isLoading, error } = useGetChatSessions();
  const session1 = sessions?.[0];
  const session2 = sessions?.[1];
  const session3 = sessions?.[2];
  return (
    <div className='bg-white h-96 rounded-md p-4'>
      <h1 className='font-bold text-lg'>Quick Links</h1>
      <Link to='/profile'>
        <div className='flex items-center hover:bg-gray-100 cursor-pointer px-2 py-3 rounded-md'>
          <img src={userProfileIcon} alt='User Profile' className='w-10 h-10' />
          <div className='ml-2'>
            <h2>User Profile</h2>
            <p className='text-xs font-light'>
              View and edit your personal information
            </p>
          </div>
        </div>
      </Link>
      <Link to='/chatbot'>
        <div className='flex items-center hover:bg-gray-100 cursor-pointer px-1 py-3 rounded-md'>
          <img src={chatbotIcon} alt='User Profile' className='w-12 h-12' />
          <div className='ml-1'>
            <h2>Chatbot</h2>
            <p className='text-xs font-light'>
              Ask our chatbot your cybersecurity threat–related questions.
            </p>
          </div>
        </div>
      </Link>
      <div className='flex items-center px-2 pt-3'>
        <img src={chatHistoryIcon} alt='User Profile' className='w-10 h-10' />
        <div className='ml-2'>
          <h2>Recent Chat</h2>
          <p className='text-xs font-light'>
            Resume your recent chatbot conversation
          </p>
        </div>
      </div>
      <div className='ml-12'>
        {session1 && (
          <Link to={`/chatbot/${session1?.session_id}`}>
            <div className='flex items-center hover:bg-gray-100 cursor-pointer px-2 py-3 rounded-md'>
              <img src={chatIcon} alt='User Profile' className='w-5 h-5' />
              <h3 className='ml-2 text-sm'>{session1.title}</h3>
            </div>
          </Link>
        )}
        {session2 && (
          <Link to={`/chatbot/${session2?.session_id}`}>
            <div className='flex items-center hover:bg-gray-100 cursor-pointer px-2 py-3 rounded-md'>
              <img src={chatIcon} alt='User Profile' className='w-5 h-5' />
              <h3 className='ml-2 text-sm'>{session2.title}</h3>
            </div>
          </Link>
        )}
        {session3 && (
          <Link to={`/chatbot/${session3?.session_id}`}>
            <div className='flex items-center hover:bg-gray-100 cursor-pointer px-2 py-3 rounded-md'>
              <img src={chatIcon} alt='User Profile' className='w-5 h-5' />
              <h3 className='ml-2 text-sm'>{session3.title}</h3>
            </div>
          </Link>
        )}
      </div>
    </div>
  );
}
